import { PROXY_PORT } from "../../proxy/index";

export function getTodayDate() {
  const today = new Date();
  const date = today.getDate();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  return `${date}-${month}-${year}`;
}
/**
 * @todo make this dynamic according to the environment later
 */
export const PROXY_URL = `http://localhost:${PROXY_PORT}`;

// function isDenoEnvironment() {
//   return typeof Deno !== "undefined";
// }

// export const REMOTE_FORECAST_CONNECTOR_ENDPOINT =
// isDenoEnvironment() ? Deno.env.get("NEXT_PUBLIC_REMOTE_FORECAST_CONNECTOR_ENDPOINT") : 'http://ocp-forecast-data-connector-v1';
//   export const REMOTE_FORECAST_CATALOG_ENDPOINT =
//   isDenoEnvironment() ? Deno.env.get("NEXT_PUBLIC_REMOTE_FORECAST_CATALOG_ENDPOINT") : 'http://ocp-forecast-catalog-v1';
//   export const REMOTE_SALES_FORECAST_ENDPOINT =
//   isDenoEnvironment() ? Deno.env.get("NEXT_PUBLIC_REMOTE_SALES_FORECAST_ENDPOINT") : 'http://ffp-sales-forecast-connector-v1';
//   export const REMOTE_SALES_ACTUALS_API_TIMESERIES_ENDPOINT =
//   isDenoEnvironment() ? Deno.env.get("SALES_ACTUALS_TIMESERIES_ENDPOINT") : 'http://ts-sales-actuals-api';
//   export const REMOTE_SALES_FORECAST_API_TIMESERIES_ENDPOINT =
//   isDenoEnvironment() ? Deno.env.get("SALES_FORECAST_API_TIMESERIES_ENDPOINT") : 'http://ts-sales-forecast-api';

  